export const REFRESH_DURATION = 4;

export const shouldFetchAgain = (now, lastFetchTime) => {
  if (!lastFetchTime) return true;
  const currentTime = new Date();
  const hours = Math.abs(currentTime - now) / 3600000;
  return hours > REFRESH_DURATION;
};
